
export function isOverrun(q): boolean {
  return q.start < Date.now() && q.start !== null && ["Order", "Quote"].includes(q.status);
}

